import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

export const GetStaffAverageTenureRequestDtoSchema = z.object({
  facilityId: z.number(),
  from: z.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/),
  to: z.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/),
  comparisonSet: z.enum(['INTERNAL', 'COMP']).optional(),
});

export const GetStaffAverageTenureResponseDtoSchema = z.object({
  currentValue: z.number().nullable(),
  marketMedian: z.number().nullable(),
  hint: z.string(),
  message: z.string(),
});

export type GetStaffAverageTenureRequestDto = z.infer<
  typeof GetStaffAverageTenureRequestDtoSchema
>;

export type GetStaffAverageTenureResponseDto = z.infer<
  typeof GetStaffAverageTenureResponseDtoSchema
>;

export const getStaffAverageTenure = async (
  params: GetStaffAverageTenureRequestDto,
  config?: AxiosRequestConfig<GetStaffAverageTenureRequestDto>
) => {
  const { facilityId, ...restParams } = params;

  return api
    .get(`/market-intelligence/facilities/${facilityId}/staff-average-tenure`, {
      params: restParams,
      ...config,
    })
    .then(responseContract(GetStaffAverageTenureResponseDtoSchema));
};
